import { LoadingSignIcon } from '@lokalise/louis'
import type { Status } from '@lokalise/translation-api-schemas'
import styles from './ProjectTag.module.css'

type ProjectTagProps = {
  type: Status | 'default' | 'updating'
}

export const ProjectTag = ({ type }: ProjectTagProps) => {
  switch (type) {
    case 'active':
      return <span className={`${styles.base} ${styles.active}`}>Active</span>
    case 'inactive':
      return <span className={`${styles.base} ${styles.inactive}`}>Inactive</span>
    case 'updating':
      return (
        <span className={`${styles.base} ${styles.inactive}`}>
          <LoadingSignIcon size="1.2em" /> Updating
        </span>
      )
    case 'default':
      return <span className={`${styles.base} ${styles.default}`}>Default</span>
    default:
      return null
  }
}

type CustomTagProps = { text?: string }

export const CustomTag = ({ text = 'Custom' }: CustomTagProps) => (
  <span className={`${styles.base} ${styles.custom}`}>{text}</span>
)
